// Layouts
import Auth from '../layouts/AuthAdmin.vue'

// Auth
import Login from '../views/authAdmin/Login.vue'
import VerifyCode from '../views/authAdmin/VerifyCode.vue'
// import ForgetPassword from '../views/authAdmin/ForgetPassword.vue'
// import ResetPassword from '../views/authAdmin/ResetPassword.vue'

const authAdminRoutes = {
  path: '/hrd12',
  redirect: '/hrd12',
  component: Auth,
  children: [
    {
      path: '/hrd12',
      component: Login,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/hrd12/verify-login/:userId',
      component: VerifyCode,
      meta: {
        title: 'Verify Login'
      }
    }
    // {
    //   path: '/hrd12/reset-password',
    //   component: ForgetPassword,
    //   meta: {
    //     title: 'Reset Password | Admin'
    //   }
    // },
    // {
    //   path: '/hrd12/password-reset/:token',
    //   component: ResetPassword,
    //   meta: {
    //     title: 'Reset Password | Admin'
    //   }
    // }
  ]
}

export default authAdminRoutes
